var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5902_4147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 23.09L4.01638 23.0902L4.80247 15.9287H0.5V23.09Z",
    fill: "#F4907B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 23.0897L4.01638 23.0899L4.80247 20.521H0.5V23.0897Z",
    fill: "#E85130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7007 19.4453L13.2264 19.274L18.8241 13.9113C19.0643 13.6805 19.3535 13.5069 19.6702 13.4035C20.3987 13.1663 21.2267 13.3154 21.8337 13.8567C22.7958 14.7136 22.8279 16.2065 21.9039 17.1035L16.5207 22.3314",
    fill: "#FFCBBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0166 23.0657H13.2506C14.3842 23.0657 15.5029 22.8062 16.5208 22.3072L23.258 19.0038C24.4145 18.4367 24.8464 17.0072 24.1975 15.8947C23.6144 14.8952 22.361 14.5119 21.3187 15.0142L14.3354 18.3796L4.0166 16.7042",
    fill: "#FFDDCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95316 18.8806H12.5801C13.0487 18.8806 13.4741 18.6966 13.7889 18.3974C14.2625 18.0077 14.5646 17.4171 14.5646 16.7558C14.5646 15.5823 13.6133 14.631 12.4399 14.631H9.6199C9.13971 13.6513 8.13326 12.9766 6.96865 12.9766C5.33829 12.9766 4.0166 14.2982 4.0166 15.9286V20.8745",
    fill: "#FFDDCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5651 16.7557C14.5651 17.4173 14.2633 18.0079 13.7896 18.3976C13.4747 18.6965 13.0493 18.8805 12.5809 18.8805H8.57114C8.23017 18.8805 7.95375 18.6041 7.95375 18.2631C7.95375 17.9221 8.23017 17.6457 8.57114 17.6457H12.5809C13.0493 17.6457 13.4747 17.4617 13.7896 17.1628C14.028 16.967 14.221 16.7216 14.3551 16.4438C14.4026 16.3453 14.4423 16.2433 14.4739 16.1386C14.5346 16.3387 14.5654 16.5466 14.5651 16.7557ZM8.12465 13.2112C7.06903 13.6613 6.32972 14.7082 6.32972 15.9285V21.2599L4.01709 20.8744V15.9285C4.01709 14.2978 5.33878 12.9761 6.96904 12.9761C7.36617 12.9757 7.75927 13.0557 8.12465 13.2112Z",
    fill: "#FFCBBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2582 19.028L16.5208 22.3315C15.5029 22.8307 14.3843 23.0902 13.2506 23.0901H4.0166V20.5215H13.2506C14.3843 20.5214 15.5029 20.2619 16.5208 19.7629L23.2582 16.4594C23.6029 16.2904 23.8835 16.0446 24.0902 15.7534C24.1286 15.8069 24.1644 15.8621 24.1974 15.9191C24.8464 17.0317 24.4147 18.4611 23.2582 19.028Z",
    fill: "#FFCBBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6338 11.9839C16.6919 11.9839 19.1709 9.50484 19.1709 6.44678C19.1709 3.38872 16.6919 0.909668 13.6338 0.909668C10.5757 0.909668 8.09668 3.38872 8.09668 6.44678C8.09668 9.50484 10.5757 11.9839 13.6338 11.9839Z",
    fill: "#FFD064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.634 10.5605C15.9059 10.5605 17.7475 8.71884 17.7475 6.44701C17.7475 4.17518 15.9059 2.3335 13.634 2.3335C11.3622 2.3335 9.52051 4.17518 9.52051 6.44701C9.52051 8.71884 11.3622 10.5605 13.634 10.5605Z",
    fill: "#FFE07D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75185 9.21323L6.69663 9.11756C6.50186 8.78006 6.079 8.65106 5.72899 8.8223L4.65236 9.34899C4.26672 9.53766 4.12155 10.0134 4.33614 10.3853L4.47339 10.623C4.68799 10.9949 5.17263 11.1072 5.52888 10.8676L6.52352 10.1988C6.84682 9.98138 6.94661 9.55069 6.75185 9.21323ZM6.04779 6.50283V6.39234C6.04783 6.00267 5.74614 5.67952 5.35741 5.6528L4.16168 5.57063C3.73338 5.54119 3.36972 5.88066 3.36968 6.30999L3.36963 6.58453C3.36958 7.01386 3.73314 7.35342 4.16144 7.32408L5.35722 7.24219C5.74596 7.21556 6.04774 6.89245 6.04779 6.50283ZM6.69227 3.77611L6.74753 3.68044C6.94239 3.34303 6.84274 2.9123 6.51944 2.6948L5.52499 2.02575C5.16879 1.78613 4.68414 1.89825 4.46941 2.27006L4.33211 2.50781C4.11743 2.87958 4.26246 3.35541 4.64805 3.54417L5.72454 4.07114C6.0745 4.24247 6.49741 4.11356 6.69227 3.77611Z",
    fill: "#FFE07D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5163 9.21323L20.5716 9.11756C20.7663 8.78006 21.1892 8.65106 21.5392 8.8223L22.6158 9.34899C23.0015 9.53766 23.1466 10.0134 22.932 10.3853L22.7948 10.623C22.5802 10.9949 22.0956 11.1072 21.7393 10.8676L20.7447 10.1988C20.4213 9.98138 20.3215 9.55069 20.5163 9.21323ZM21.2204 6.50283V6.39234C21.2204 6.00267 21.522 5.67952 21.9108 5.6528L23.1065 5.57063C23.5348 5.54119 23.8985 5.88066 23.8985 6.30999L23.8986 6.58453C23.8986 7.01386 23.535 7.35342 23.1067 7.32408L21.911 7.24219C21.5222 7.21556 21.2205 6.89245 21.2204 6.50283ZM20.5759 3.77611L20.5206 3.68044C20.3257 3.34303 20.4254 2.9123 20.7487 2.6948L21.7432 2.02575C22.0994 1.78613 22.584 1.89825 22.7987 2.27006L22.936 2.50781C23.1507 2.87958 23.0057 3.35541 22.6201 3.54417L21.5436 4.07114C21.1936 4.24247 20.7708 4.11356 20.5759 3.77611Z",
    fill: "#FFE07D"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5902_4147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.475 5.45063C16.1328 4.99221 15.6467 4.73975 15.1066 4.73975C14.5664 4.73975 14.0804 4.99221 13.7381 5.45063C13.4171 5.88065 13.2402 6.46632 13.2402 7.09977C13.2402 7.73322 13.4171 8.31889 13.7381 8.74891C14.0804 9.20733 14.5664 9.45979 15.1066 9.45979C15.6467 9.45979 16.1328 9.20733 16.475 8.74891C16.7961 8.31889 16.9729 7.73322 16.9729 7.09977C16.9729 6.46632 16.7961 5.88065 16.475 5.45063Z",
    fill: "url(#paint0_linear_5902_4147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0429 5.45063C13.7006 4.99221 13.2146 4.73975 12.6745 4.73975C12.1343 4.73975 11.6483 4.99221 11.306 5.45063C10.9849 5.88065 10.8081 6.46632 10.8081 7.09977C10.8081 7.73322 10.9849 8.31889 11.306 8.74891C11.6483 9.20733 12.1343 9.45979 12.6745 9.45979C13.2146 9.45979 13.7006 9.20733 14.0429 8.74891C14.364 8.31889 14.5408 7.73322 14.5408 7.09977C14.5408 6.46632 14.364 5.88065 14.0429 5.45063Z",
    fill: "url(#paint1_linear_5902_4147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2593 5.45063C14.917 4.99221 14.431 4.73975 13.8908 4.73975L12.8071 7.09977L13.8908 9.45979C14.431 9.45979 14.917 9.20733 15.2593 8.74891C15.5803 8.31889 15.7572 7.73322 15.7572 7.09977C15.7572 6.46632 15.5803 5.88065 15.2593 5.45063Z",
    fill: "url(#paint2_linear_5902_4147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5223 5.45063C12.2012 5.88065 12.0244 6.46632 12.0244 7.09977C12.0244 7.73322 12.2012 8.31889 12.5223 8.74891C12.8646 9.20733 13.3506 9.45979 13.8908 9.45979V4.73975C13.3506 4.73975 12.8646 4.99221 12.5223 5.45063Z",
    fill: "url(#paint3_linear_5902_4147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7301 3.69853C13.4701 3.51883 13.1713 3.66592 13.039 3.65708C12.9545 3.65148 12.8353 3.60298 12.7003 3.39734C12.6365 3.55424 12.645 3.73735 12.7231 3.88705C12.8013 4.03674 12.9355 4.15904 13.1024 4.1995C13.2357 4.23182 13.3486 4.18924 13.4949 4.23537C13.6464 4.28313 13.756 4.4207 13.7972 4.56267C13.8098 4.53132 13.8807 4.37588 13.9046 4.19795C13.9285 4.02003 13.9054 3.8197 13.7301 3.69853Z",
    fill: "url(#paint4_linear_5902_4147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8065 3.73553C12.8066 3.73978 12.9132 3.81857 13.1849 3.77555C13.4806 3.72877 13.6418 3.72855 13.7356 3.84236C13.8236 3.94915 13.8392 4.23766 13.8169 4.38639C13.8159 4.37651 13.7379 4.19306 13.4332 4.15817C13.2255 4.13432 13.0697 4.08388 12.9655 4.01173C12.8612 3.93968 12.8084 3.8459 12.8065 3.73553Z",
    fill: "url(#paint5_linear_5902_4147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1724 3.92432C13.1728 3.92637 13.231 3.95826 13.3625 3.91887C13.5057 3.87601 13.5854 3.86515 13.6398 3.91516C13.6907 3.96205 13.7187 4.1036 13.718 4.17852C13.7167 4.17367 13.6654 4.08829 13.5121 4.09131C13.4076 4.09339 13.3271 4.07882 13.2704 4.05018C13.2137 4.02153 13.1811 3.97872 13.1724 3.92432Z",
    fill: "url(#paint6_linear_5902_4147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.687 4.03004C12.7539 4.14269 12.936 4.36914 13.2881 4.31698C13.4945 4.28641 13.6985 4.38035 13.7995 4.55833L13.803 4.56454C13.5985 4.3215 13.0671 4.73892 12.687 4.03004Z",
    fill: "url(#paint7_linear_5902_4147)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5902_4147",
    x1: 13.2402,
    y1: 7.09977,
    x2: 16.9729,
    y2: 7.09977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#F77D51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5902_4147",
    x1: 11.4843,
    y1: 7.09977,
    x2: 17.0625,
    y2: 7.09977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF918A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5902_4147",
    x1: 12.8071,
    y1: 7.09977,
    x2: 15.7572,
    y2: 7.09977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5902_4147",
    x1: 12.0244,
    y1: 7.09977,
    x2: 13.8908,
    y2: 7.09977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD746C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9068"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5902_4147",
    x1: 13.6774,
    y1: 3.61924,
    x2: 12.991,
    y2: 4.22156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD746C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9068"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5902_4147",
    x1: 13.666,
    y1: 3.76283,
    x2: 13.1366,
    y2: 4.2273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7342B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9068"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5902_4147",
    x1: 13.4167,
    y1: 3.87857,
    x2: 13.4812,
    y2: 4.22289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00512821,
    stopColor: "#FF9803"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9949,
    stopColor: "#FAF154"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5902_4147",
    x1: 13.4398,
    y1: 4.13335,
    x2: 13.0423,
    y2: 4.48215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD746C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9068"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5902_4147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5902_4147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    fill: "white",
    transform: "translate(10.5 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip);
export default __webpack_public_path__ + "static/media/tip.20cd2e96a3120d77562a039b6e56efb5.svg";
export { ForwardRef as ReactComponent };